import { useGraphqlMutation } from "@harea/component";
import { TNotification } from "@harea/component";

export const useNotificationMarkAllAsReadMutation = () => {
    return useGraphqlMutation<TNotification[]>(gql);
};

const gql = `
    mutation($data: [JSONObject!]) {
        saveNotification(data: { datas: $data }) {
            ids
        }
    }
`;
